/**
 * Fabric / print swatches — ported from retail Sugarlips for Dawn wholesale.
 * - Collection cards: click swaps card via ?view=ajax
 * - Product page: links to related print products
 * Metafield: product.metafields.options.fabrics (JSON)
 */
(function () {
  var MAX_SWATCHES = 4;
  // Retail Sugarlips Files CDN — fabric swatch filenames in metafields live there
  var RETAIL_FILES_CDN = 'https://cdn.shopify.com/s/files/1/2510/3662/files/';
  var isRunning = false;
  var debounceTimer = null;
  var availabilityCache = Object.create(null);
  var imageCache = Object.create(null);
  var inflight = Object.create(null);

  window.Swatchy = window.Swatchy || {};
  window.Swatchy.refresh = scheduleInit;

  function scheduleInit() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      buildFabricSwatches();
      initSwatches();
    }, 120);
  }

  function cssEscape(str) {
    if (window.CSS && typeof window.CSS.escape === 'function') return window.CSS.escape(str);
    return String(str).replace(/[^a-zA-Z0-9_-]/g, '\\$&');
  }

  function fileImageUrl(filename) {
    if (!filename) return '';
    if (typeof filename === 'object') {
      filename = filename.src || filename.url || filename.preview_image || '';
    }
    filename = String(filename).trim();
    if (!filename) return '';
    if (/^(https?:)?\/\//i.test(filename)) return filename;
    // Bare filenames were authored against the retail Files library
    return RETAIL_FILES_CDN + filename.replace(/^\//, '');
  }

  function setSwatchBackground(el, url) {
    if (!el || !url) return;
    el.style.backgroundImage = 'url("' + String(url).replace(/"/g, '\\"') + '")';
  }

  function buildFabricSwatches() {
    var wraps = document.querySelectorAll('.fabric-swatches-wrap:not([data-built])');

    wraps.forEach(function (wrap) {
      var parentHandle = wrap.getAttribute('data-parent-handle');
      var dataEl = wrap.querySelector('.fabric-swatches-data');
      if (!parentHandle || !dataEl) return;

      var fabrics;
      try {
        fabrics = JSON.parse(dataEl.textContent || '[]');
        // Text metafields may already be a JSON string; json-type uses | json once
        if (typeof fabrics === 'string') {
          fabrics = JSON.parse(fabrics);
        }
      } catch (e) {
        return;
      }

      if (!Array.isArray(fabrics) || !fabrics.length) return;

      wrap.setAttribute('data-built', 'true');
      dataEl.parentNode.removeChild(dataEl);

      var renderMode = wrap.getAttribute('data-render');
      var currentName = '';
      var isLinkMode = renderMode === 'links';
      var swatchClass = isLinkMode ? 'swatchy swatchy-link' : 'swatchy swatchy-clicky';

      fabrics.forEach(function (swatch) {
        if (!swatch || !swatch.handle) return;

        if (parentHandle === swatch.handle && swatch.swatchName) {
          currentName = swatch.swatchName;
        }

        var isCurrent = parentHandle === swatch.handle;
        var borderColor = isCurrent ? '#252525' : isLinkMode ? '#FFFFFF' : '#DDDDDD';
        var el = document.createElement('div');

        el.className = swatchClass;
        el.setAttribute('data-handle', swatch.handle);
        el.setAttribute('data-parent-handle', parentHandle);
        el.style.borderColor = borderColor;
        el.style.display = 'none';

        var imageUrl = fileImageUrl(swatch.image || swatch.Image || swatch.img);

        if (isLinkMode) {
          el.innerHTML =
            '<a href="/products/' +
            encodeURIComponent(swatch.handle) +
            '" aria-label="' +
            (swatch.swatchName || swatch.handle).replace(/"/g, '&quot;') +
            '"><span class="swatch__list--item"></span></a>';
        } else {
          el.innerHTML =
            '<button type="button" class="load-swatch" aria-label="' +
            (swatch.swatchName || swatch.handle).replace(/"/g, '&quot;') +
            '"><span class="swatch__list--item imagey"></span></button>';
        }

        setSwatchBackground(el.querySelector('.swatch__list--item'), imageUrl);
        wrap.appendChild(el);
      });

      if (currentName) {
        document.querySelectorAll('.fabric-swatches-title[data-parent-handle]').forEach(function (titleEl) {
          if (titleEl.getAttribute('data-parent-handle') === parentHandle) {
            titleEl.textContent = 'Print: ' + currentName;
          }
        });
      }

      if (!isLinkMode && fabrics.length > MAX_SWATCHES) {
        var extraLink = document.createElement('a');
        extraLink.href = '/products/' + encodeURIComponent(parentHandle);
        extraLink.className = 'fabric-swatches-extra-link';
        extraLink.innerHTML =
          '<span class="extra-swatchy-' +
          parentHandle +
          ' swatchy extra-swatchy" style="display: none;"></span>';
        wrap.appendChild(extraLink);
      }
    });
  }

  function initSwatches() {
    if (isRunning) return;
    isRunning = true;

    var allSwatches = Array.prototype.slice
      .call(
        document.querySelectorAll(
          '.swatchy-clicky[data-handle][data-parent-handle], .swatchy-link[data-handle][data-parent-handle]'
        )
      )
      .filter(function (el) {
        return el.getAttribute('data-handle');
      });

    if (!allSwatches.length) {
      isRunning = false;
      return;
    }

    var byParent = {};
    allSwatches.forEach(function (el) {
      var parent = el.getAttribute('data-parent-handle');
      if (!parent) return;
      if (!byParent[parent]) byParent[parent] = [];
      byParent[parent].push(el);
    });

    for (var parent in byParent) {
      var extraEl = document.querySelector('.extra-swatchy-' + cssEscape(parent));
      if (extraEl) extraEl.style.display = 'none';
    }

    var handles = [];
    allSwatches.forEach(function (s) {
      var h = s.getAttribute('data-handle');
      if (h && handles.indexOf(h) === -1) handles.push(h);
    });

    var toFetch = handles.filter(function (h) {
      return availabilityCache[h] === undefined;
    });

    if (!toFetch.length) {
      applySwatches(byParent, availabilityCache);
      isRunning = false;
      return;
    }

    var promises = toFetch.map(function (handle) {
      if (inflight[handle]) return inflight[handle];

      inflight[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', {
        credentials: 'same-origin',
        cache: 'force-cache',
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Bad response');
          return res.json();
        })
                .then(function (product) {
                  availabilityCache[handle] = !!(product && product.available);
                  if (product && product.featured_image) {
                    imageCache[handle] = product.featured_image;
                  } else if (product && product.images && product.images.length) {
                    imageCache[handle] = product.images[0].src || product.images[0];
                  }
                })
                .catch(function () {
                  availabilityCache[handle] = false;
                })
        .finally(function () {
          delete inflight[handle];
        });

      return inflight[handle];
    });

    Promise.all(promises)
      .then(function () {
        applySwatches(byParent, availabilityCache);
      })
      .finally(function () {
        isRunning = false;
      });
  }

  function applySwatches(byParent, availability) {
    for (var parent in byParent) {
      var swatches = byParent[parent];
      var isLinkMode = swatches[0] && swatches[0].classList.contains('swatchy-link');

      for (var i = 0; i < swatches.length; i++) {
        swatches[i].style.display = 'none';
      }

      var availableSwatches = [];
      for (var j = 0; j < swatches.length; j++) {
        var el = swatches[j];
        var handle = el.getAttribute('data-handle');
        if (handle && availability[handle]) availableSwatches.push(el);
      }

      var maxToShow = isLinkMode ? availableSwatches.length : MAX_SWATCHES;
      for (var k = 0; k < Math.min(maxToShow, availableSwatches.length); k++) {
        var swatchEl = availableSwatches[k];
        swatchEl.style.display = 'inline-block';

        // Fall back to the related product's featured image when file CDN swatch is missing
        var swatchHandle = swatchEl.getAttribute('data-handle');
        var imgEl = swatchEl.querySelector('.swatch__list--item');
        if (imgEl && imageCache[swatchHandle]) {
          var existing = imgEl.style.backgroundImage || '';
          if (!existing || existing === 'none' || existing === 'url()' || existing === 'url("")') {
            setSwatchBackground(imgEl, imageCache[swatchHandle]);
          } else {
            // Still attach an onerror fallback via a probe image
            (function (target, fallbackUrl) {
              var probe = new Image();
              probe.onload = function () {};
              probe.onerror = function () {
                setSwatchBackground(target, fallbackUrl);
              };
              var match = (target.style.backgroundImage || '').match(/url\(["']?(.*?)["']?\)/);
              if (match && match[1]) probe.src = match[1];
            })(imgEl, imageCache[swatchHandle]);
          }
        }
      }

      if (isLinkMode) {
        document.querySelectorAll('.fabric-swatches-title[data-parent-handle]').forEach(function (titleEl) {
          if (titleEl.getAttribute('data-parent-handle') === parent) {
            titleEl.style.display = availableSwatches.length ? '' : 'none';
          }
        });
        continue;
      }

      var remaining = Math.max(0, availableSwatches.length - MAX_SWATCHES);
      var extraEl = document.querySelector('.extra-swatchy-' + cssEscape(parent));

            if (extraEl) {
                if (remaining > 0) {
                    extraEl.textContent = '+' + remaining;
                    extraEl.style.display = 'inline-flex';
                } else {
                    extraEl.textContent = '';
                    extraEl.style.display = 'none';
                }
            }
    }
  }

  function startObserver() {
    var target =
      document.querySelector('#MainContent') ||
      document.querySelector('.main-content') ||
      document.body;
    if (!target) return;

    var obs = new MutationObserver(function () {
      scheduleInit();
    });
    obs.observe(target, { childList: true, subtree: true });
  }

  function onSwatchClick(event) {
    var target = event.target.closest('.swatchy-clicky');
    if (!target) return;

    // Stop Dawn's stretched card link (.card__heading a::after) from navigating
    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }

    var handle = target.getAttribute('data-handle');
    var parentHandle = target.getAttribute('data-parent-handle');
    if (!handle || !parentHandle || handle === parentHandle) return;

    // Prefer the analytics wrapper, then the card. Do not rely on
    // [data-product-id=handle] — cards never set that attribute.
    var oldProduct =
      target.closest('product-component') || target.closest('.card-wrapper');
    if (!oldProduct) return;

    oldProduct.classList.add('fabric-swatch-loading');

    fetch('/products/' + encodeURIComponent(handle) + '?view=ajax', {
      credentials: 'same-origin',
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Bad response');
        return res.text();
      })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newProduct =
          doc.querySelector('product-component') ||
          doc.querySelector('.card-wrapper') ||
          doc.querySelector('[data-product-id="' + cssEscape(handle) + '"]') ||
          doc.body.querySelector('[data-product-id]');

        if (!newProduct) {
          console.warn('Ajax product markup not found for handle:', handle);
          oldProduct.classList.remove('fabric-swatch-loading');
          return;
        }

        // Prefer matching wrapper levels so we don't nest product-component.
        if (
          oldProduct.matches('product-component') &&
          newProduct.matches('.card-wrapper') &&
          newProduct.closest('product-component')
        ) {
          newProduct = newProduct.closest('product-component');
        } else if (
          oldProduct.matches('.card-wrapper') &&
          newProduct.matches('product-component')
        ) {
          newProduct = newProduct.querySelector('.card-wrapper') || newProduct;
        }

        // Retail pattern: replace entire card so image, title, style #, price update together
        oldProduct.replaceWith(document.importNode(newProduct, true));

        if (window.Swatchy && typeof window.Swatchy.refresh === 'function') {
          window.Swatchy.refresh();
        }
        if (window.__SPP_REPAIR && typeof window.__SPP_REPAIR.run === 'function') {
          window.setTimeout(window.__SPP_REPAIR.run, 50);
          window.setTimeout(window.__SPP_REPAIR.run, 250);
        }
      })
      .catch(function () {
        console.error('Error loading product:', handle);
        oldProduct.classList.remove('fabric-swatch-loading');
      });
  }

  document.addEventListener('DOMContentLoaded', function () {
    buildFabricSwatches();
    initSwatches();
    startObserver();
    document.addEventListener('click', onSwatchClick, true);
  });
})();

